import { createContext, useContext, useEffect, useMemo, useState } from "react";

const CartContext = createContext(null);
export const useCart = () => useContext(CartContext);

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem("luxa_cart") || "[]"); } catch { return []; }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => { localStorage.setItem("luxa_cart", JSON.stringify(items)); }, [items]);

  const add = (product, quantity = 1) => {
    setItems((prev) => {
      const found = prev.find((i) => i.product_id === product.id);
      if (found) return prev.map((i) => (i.product_id === product.id ? { ...i, quantity: i.quantity + quantity } : i));
      return [...prev, { product_id: product.id, name: product.name, price: product.price,
        image: product.images?.[0] || "", slug: product.slug, quantity }];
    });
    setOpen(true);
  };
  const setQty = (id, q) =>
    setItems((prev) => (q <= 0 ? prev.filter((i) => i.product_id !== id)
      : prev.map((i) => (i.product_id === id ? { ...i, quantity: q } : i))));
  const remove = (id) => setItems((prev) => prev.filter((i) => i.product_id !== id));
  const clear = () => setItems([]);

  const subtotal = useMemo(() => items.reduce((s, i) => s + i.price * i.quantity, 0), [items]);
  const shipping = items.length === 0 || subtotal >= 150 ? 0 : 12;
  const count = items.reduce((s, i) => s + i.quantity, 0);

  return (
    <CartContext.Provider value={{ items, add, setQty, remove, clear, subtotal, shipping, total: subtotal + shipping, count, open, setOpen }}>
      {children}
    </CartContext.Provider>
  );
};
